import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import area from './modules/area'
import common from './modules/common'
import masterData from './modules/masterData'
import param from './modules/param'
import system from './modules/system'
import truck from './modules/truck'
import language from './modules/language'
import settings from './modules/settings'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    common,
    param,
    area,
    truck,
    masterData,
    system,
    language,
    settings
  },
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js